
  <tabset>
    <tab heading="Press Releases">
      <div class="General container-fluid">
        <h3>{{"Newsroom.SearchTitle" | translate}}</h3>
        <!-- <h3>{{"Newsroom.Archived" | translate}}</h3> -->
        <div *ngIf="newsPressRelease" class="row NewsItems">
          <div *ngFor="let item of returnNewsPress" class="col-md-6 col-lg-4  d-flex alight-items-stretch mb-4">
            <a href="{{item.linkUrl}}" target="_blank" class="card grow">
              <img class="card-img-top" src="{{item.imageUrl}}" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title">{{item.title}}</h5>
                <p class="card-date">{{item.newsDate | date}}</p>
                <p class="card-text">{{item.description}}</p>

              </div>
            </a>
          </div>
          <div class="w-100">
            <div style="display: flex;
            justify-content: flex-end;
            margin-right: 2em;">
              <pagination [boundaryLinks]="showBoundaryLinks"
              [directionLinks]="showDirectionLinks"
              [totalItems]="newsPressRelease.length"
              [itemsPerPage]="9"
              [maxSize]="5"
              (pageChanged)="pageChangedPress($event)"  previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"></pagination>
            </div>

          </div>
        </div>
      </div>
    </tab>
    <tab heading="Press / Media" id="tab1">
      <div class="General container-fluid">
        <h3>{{"Newsroom.SearchTitle" | translate}}</h3>
        <div *ngIf="newsRecent" class="row NewsItems">

          <div *ngFor="let item of returnNewsRecent" class="col-md-6 col-lg-4 d-flex alight-items-stretch mb-4">
            <a href="{{item.linkUrl}}" target="_blank" class="card grow">
              <img class="card-img-top" src="{{item.imageUrl}}" alt="Card image cap">
              <div class="card-body">
                <h5 class="card-title">{{item.title}}</h5>
                <p class="card-date">{{item.newsDate | date}}</p>
                <p class="card-text">{{item.description}}</p>

              </div>
            </a>
          </div>
          <div class="w-100">
            <div style="display: flex;
            justify-content: flex-end;
            margin-right: 2em;">
              <pagination
              [boundaryLinks]="showBoundaryLinks"
              [directionLinks]="showDirectionLinks"
              [totalItems]="newsRecent.length"
              [itemsPerPage]="9"
              [maxSize]="5"

              (pageChanged)="pageChanged($event)"  previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"></pagination>
            </div>

          </div>
        </div>
      </div>
    </tab>

    <!--
    <tab heading="SOCIAL MEDIA">
      <div class="General container-fluid">
        <div class="row">

          <div class="col-md">
            <a class="twitter-timeline"
              href="https://twitter.com/lacassessor"
              data-width="500"
              data-height="500">

              Tweets by @LACAssessor
            </a>
          </div>

          <div class="col-md">

            <div id="fb-root"></div>
            <script async defer crossorigin="anonymous" src="https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v11.0" nonce="ew5EdivY"></script>

            <div class="fb-page" data-href="https://www.facebook.com/lacassessor" data-tabs="timeline" data-width="500" data-height="500" data-small-header="false" data-adapt-container-width="true" data-hide-cover="true" data-show-facepile="false"><blockquote cite="https://www.facebook.com/lacassessor" class="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/lacassessor">Assessor Jeff Prang</a></blockquote></div>
          </div>

        </div>

      </div>
    </tab>
-->
  </tabset>



